import { ApolloClient, InMemoryCache } from "@apollo/client"

const getSubgraphUrl = (chainId: number) => {
  let chainUrl = ""

  switch (chainId) {
    case 5:
      chainUrl = "goerli"
      break
    case 8453:
      chainUrl = "base"
      break
    case 84531:
      chainUrl = "base-goerli"
      break
    default:
      chainUrl = "base"
  }

  return `https://api.studio.thegraph.com/query/5023/slice-${chainUrl}/version/latest`
}

export const client = (chainId: number) => {
  const APIURL = getSubgraphUrl(chainId)

  return new ApolloClient({
    uri: APIURL,
    cache: new InMemoryCache()
  })
}
